
import React from "react";
import { Button } from "@/components/ui/button";

interface UserProfilesEmptyStateProps {
  onRefresh: () => void;
}

const UserProfilesEmptyState: React.FC<UserProfilesEmptyStateProps> = ({ onRefresh }) => {
  return (
    <div className="text-center py-8">
      <p className="text-muted-foreground text-sm mt-1">
        Looking for more users to connect with, or no other users have completed their profiles yet.
      </p>
      <Button 
        variant="outline" 
        className="mt-4"
        onClick={onRefresh}
      >
        Refresh
      </Button>
    </div>
  );
};

export default UserProfilesEmptyState;

